@if (searchService.searchError$ | async; as error) {
  <rotec-service-error-v2> </rotec-service-error-v2>
} @else {
  <div class="header-row">
    <div>
      @if (userRightsService.hasActionRights$(actions.addTask) | async) {
        <button bullet rotec-button-active (click)="addNewTask()" icon="plus">
          {{ 'Add Task' | translate }}
        </button>
      }
    </div>
    <rotec-radio-row-v2
      [options]="searchService.responsibleCompanyOptions"
      [selected]="state.responsibleCompanyFilterValue"
      [spaceEvenly]="true"
      (selectedChange)="searchService.filterForResponsible($event)"
    ></rotec-radio-row-v2>
  </div>
  <div class="task-search">
    <rotec-default-grid-v2
      [height]="gridHeight"
      [columns]="state.columns"
      (columnsChange)="updateColumnSettings($event)"
      [data]="state.searchData"
      [controlButtons]="controlButtons"
      (stateChange)="refineSearch($event)"
      [selectConfig]="{
        checkboxAlwaysVisible: true,
        checkboxToggleOnWholeRow: false,
      }"
      [selectedResults]="state.searchData.selectedIds"
      (selectedResultsChange)="searchService.setSelectedResults($event)"
      (selectedItemChanged)="toggleSelectedItem($event)"
      (rowClick)="openTask($event)"
      (addEntry)="addNewTask()"
      [filterButton]="false"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      (fulltextSearchChanged)="keyupEnterSearch($event)"
      [fixedSpinner]="true"
    >
      <ng-template rotecGridCellV2="toolingName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.toolingName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="manufacturer" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.manufacturer || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="inventoryNo" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.inventoryNo || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="serial" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.serial || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckMatNo" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckMatNo || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="verificationLevel" let-dataItem="dataItem">
        <p class="grid-text-cell">
          {{ dataItem.verificationLevel || '-' | rotecToolingVerificationLevel }}
        </p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="customerId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.customerId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="title" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.title || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="priority" let-dataItem="dataItem">
        <ma-priority
          class="grid-text-cell"
          [priority]="dataItem.priority"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-priority>
      </ng-template>
      <ng-template rotecGridCellV2="responsibleCompany" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsibleCompany || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsible || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executive" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.executive || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="dueDate" let-dataItem="dataItem">
        <ma-date
          class="grid-text-cell"
          [date]="dataItem.dueDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-date>
      </ng-template>
      <ng-template rotecGridCellV2="status" let-dataItem="dataItem">
        <div class="grid-text-cell">
          <ma-status
            [dueDate]="dataItem.dueDate"
            [referenceDate]="dataItem.referenceDate"
            [status]="dataItem.status"
            [isSelected]="isSelected(dataItem.id)"
          ></ma-status>
        </div>
      </ng-template>
      <ng-template rotecGridCellV2="description" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.description || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="type" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.type | typeEnum }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="expectedDurationMinutes" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.expectedDurationMinutes || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.scheduling | taskInterval }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machines" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machines || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="toolingForRotor" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.toolingForRotor || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="mainContact" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.mainContact || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="storageLocation" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.storageLocation || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="workplace" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.workplace || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="documentIds" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.documentIds || '-' }}</p>
      </ng-template>
    </rotec-default-grid-v2>
  </div>
}

<ng-template #content>
  <div class="header-row">
    <div>
      @if (userRightsService.hasActionRights$(actions.addTask) | async) {
        <button bullet rotec-button-active (click)="addNewTask()" icon="plus">
          {{ 'Add Task' | translate }}
        </button>
      }
    </div>
    <rotec-radio-row-v2
      [options]="searchService.responsibleCompanyOptions"
      [selected]="state.responsibleCompanyFilterValue"
      [spaceEvenly]="true"
      (selectedChange)="searchService.filterForResponsible($event)"
    ></rotec-radio-row-v2>
  </div>

  <div class="task-search">
    <rotec-default-grid-v2
      [height]="gridHeight"
      [columns]="state.columns"
      (columnsChange)="updateColumnSettings($event)"
      [data]="state.searchData"
      [controlButtons]="controlButtons"
      (stateChange)="refineSearch($event)"
      [selectConfig]="{
        checkboxAlwaysVisible: true,
        checkboxToggleOnWholeRow: false,
      }"
      [selectedResults]="state.searchData.selectedIds"
      (selectedResultsChange)="searchService.setSelectedResults($event)"
      (selectedItemChanged)="toggleSelectedItem($event)"
      (rowClick)="openTask($event)"
      (addEntry)="addNewTask()"
      [filterButton]="false"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      (fulltextSearchChanged)="keyupEnterSearch($event)"
      [fixedSpinner]="true"
    >
      <ng-template rotecGridCellV2="toolingName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.toolingName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="manufacturer" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.manufacturer || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="inventoryNo" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.inventoryNo || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="serial" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.serial || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckMatNo" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckMatNo || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="verificationLevel" let-dataItem="dataItem">
        <p class="grid-text-cell">
          {{ dataItem.verificationLevel || '-' | rotecToolingVerificationLevel }}
        </p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="customerId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.customerId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="title" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.title || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="priority" let-dataItem="dataItem">
        <ma-priority
          class="grid-text-cell"
          [priority]="dataItem.priority"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-priority>
      </ng-template>
      <ng-template rotecGridCellV2="responsibleCompany" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsibleCompany || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsible || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executive" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.executive || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="dueDate" let-dataItem="dataItem">
        <ma-date
          class="grid-text-cell"
          [date]="dataItem.dueDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-date>
      </ng-template>
      <ng-template rotecGridCellV2="status" let-dataItem="dataItem">
        <div class="grid-text-cell">
          <ma-status
            [dueDate]="dataItem.dueDate"
            [referenceDate]="dataItem.referenceDate"
            [status]="dataItem.status"
            [isSelected]="isSelected(dataItem.id)"
          ></ma-status>
        </div>
      </ng-template>
      <ng-template rotecGridCellV2="description" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.description || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="type" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.type | typeEnum }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="expectedDurationMinutes" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.expectedDurationMinutes || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.scheduling | taskInterval }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machines" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machines || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="toolingForRotor" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.toolingForRotor || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="mainContact" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.mainContact || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="storageLocation" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.storageLocation || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="workplace" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.workplace || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="documentIds" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.documentIds || '-' }}</p>
      </ng-template>
    </rotec-default-grid-v2>
  </div>
</ng-template>

<ng-template #statusFilter let-value="value" let-changeValue="changeValue">
  <ma-status-filter [value]="value" (valueChange)="changeValue($event)"></ma-status-filter>
</ng-template>
